<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="店铺名称" prop="shopName" >
        <a-input v-model="form.shopName" disabled />
      </a-form-model-item>
      <a-form-model-item label="店铺简称" prop="abbreviation" >
        <a-input v-model="form.abbreviation" placeholder="请输入店铺简称" />
      </a-form-model-item>
      <a-form-model-item label="元宝" prop="ingot" >
        <a-input-number v-model="form.ingot" :min="0" :max="99999" placeholder="请输入元宝" />
      </a-form-model-item>
      <a-form-model-item label="是否含有测本资格" prop="haveTestQualifications" >
<!--        <a-input v-model="form.haveTestQualifications" placeholder="请输入是否含有测本资格 0.否 1.是" />-->
        <a-switch v-model="form.haveTestQualifications" /> {{ form.haveTestQualifications ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="是否设置电子围栏" prop="isSetFence" >
        <a-switch v-model="form.isSetFence" /> {{ form.isSetFence ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="电子围栏范围 单位:公里" prop="geofenceRadius" >
        <a-input-number v-model="form.geofenceRadius" :min="0" :step="1" :precision="0" placeholder="请输入电子围栏范围" />
      </a-form-model-item>
      <a-form-item label="免费申领权限范围" prop="freeApplyClaimScope">
        <a-select v-model="form.freeApplyClaimScope" placeholder="请选择免费申领权限范围" allow-clear>
          <a-select-option :value="1">白名单</a-select-option>
          <a-select-option :value="2">黑名单</a-select-option>
        </a-select>
      </a-form-item>
<!--      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" v-if="formType === 1">-->
<!--        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="版本号" prop="version" v-if="formType === 1">-->
<!--        <a-input v-model="form.version" placeholder="请输入版本号" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShop, addShop, updateShop } from '@/api/played/shop'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        shopId: null,
        shopName: null,
        abbreviation: null,
        ingot: null,
        haveTestQualifications: undefined,
        geofenceRadius: undefined,
        isSetFence: undefined,
        freeApplyClaimScope: undefined,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        ingot: [
          { required: true, message: '元宝不能为空', trigger: 'blur' }
        ],
        haveTestQualifications: [
          { required: true, message: '请选择是否含有测本资格', trigger: 'blur' }
        ],
        isSetFence: [
          { required: true, message: '是否设置电子围栏', trigger: 'blur' }
        ]
        // isDeleted: [
        //   { required: true, message: '逻辑删除标记 1:删除,0:未删除不能为空', trigger: 'blur' }
        // ],
        // version: [
        //   { required: true, message: '版本号不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        shopId: null,
        abbreviation: null,
        ingot: null,
        haveTestQualifications: undefined,
        geofenceRadius: undefined,
        isSetFence: undefined,
        freeApplyClaimScope: undefined,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const shopId = row ? row.shopId : ids
      getShop(shopId).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.shopId !== undefined && this.form.shopId !== null) {
            updateShop(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addShop(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
